<template>
  <div>
    <div class="content-top idm-player" id="content_top">
      <div class="wrap-content" id="wrap_content">
        <div v-if="0" class="main-title">ET Corporate Onboarding Video
        </div>
        <div class="player-box horizontal">
          <div id="idm-player"></div>
        </div>
      </div>
    </div>
    <div class="content-middle">
      <div class="buttons-container">
        <div class="btn-box">
          <a v-if="0" :href="cl" class="btn-cfa idm-cta-btn1"
            target="_blank">Contact your Implementation Consultant</a>
        </div>
      </div>
    </div>
    <div class="content-bottom">
      <div class="wrap-bottom">
        <div class="clearfix footer">
          <div class="legal">
            <p v-if="0" style="text-align: center; text-decoration: underline;">Terms and Conditions</p>
            <p v-if="0" class="legal-block" style="text-align: center">
              Not all Cards are eligible to get rewards. Terms and limitations vary by Card type.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data:()=>{
    return {
      player_options:{
        build_url: 'https://v.idomoo.com/',
        extension: 'mp4',
        size: "wide",
        analytics_env: "us",
        ratio: "1:1",
        autoplay: false,
        mute: false,
        idm_logo: false,
        fade_control_bar: true,
        toolbar_position: "low",
        share_button: false,
        interactive: true,
        /*close_captions: [
          {
            "srclang": "en",
            "label": "English"
          }
        ],*/
        cta_analytics: [["idm-cta-btn1", "Contact your Implementation Consultant"]],
      },
      createTimeout:null,
      cl:'https://experience.americanexpress.com/ADRequestForm'
    }
  },
  mounted(){

    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('cl')){
      this.cl = urlParams.get('cl')
    }

    this.createTimeout = setTimeout(()=>{
      window.idmPlayerCreate(this.player_options, "idm-player");
    }, 100);
  },
  beforeUnmount() {
    clearTimeout(this.createTimeout)
    if(window["idm-player"].dispose){
      window["idm-player"].dispose()
    }
  }
}
</script>

<style scoped>
.idm-lp .player-box {
	width: 60vh !important;
	min-width: 350px;
	margin: 0 auto;
  
}

@media (max-width: 1600px) {
	.idm-lp .player-box {
		width: 50vh !important;
	}

	.idm-lp .content-top {
		padding-bottom: 10px !important;;
		padding-top: 10px !important;;
	}
}


</style>